import React from 'react';
import { Link } from 'react-router-dom';
import DrawerToggleButton from '../Sidebar/DrawerToggleButton';
import './Toolbar.css';

const toolbar = props => (
    <header className="toolbar">
      <nav className="toolbar__navigation">
        <div className="toolbar__toogle-button">
          <DrawerToggleButton click={props.drawerClickHandler}/>
        </div>
        <div className="spacer"></div>
        <div className="toolbar__navigation-items">
          <ul>
            <li><Link to="/v1">HOME</Link></li>
            <li><Link to="/v1/about">ABOUT</Link></li>
            <li><Link to="/v1/resume">RESUME</Link></li>
            <li><Link to="/v1/portfolios">PORTFOLIOS</Link></li>
            <li><Link to="/v1/contact">CONTACT</Link></li>
          </ul>
        </div>
      </nav>
    </header>
);

export default toolbar;
